declare namespace $ {

	type $shm_hitalama_taskmanager_column__title_shm_hitalama_taskmanager_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_taskmanager_column['title'] >
	>
	type $shm_hitalama_taskmanager_column__status_shm_hitalama_taskmanager_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_taskmanager_column['status'] >
	>
	type $shm_hitalama_taskmanager_column__tasks_shm_hitalama_taskmanager_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager['tasks_by_status'] >
		,
		ReturnType< $shm_hitalama_taskmanager_column['tasks'] >
	>
	type $shm_hitalama_taskmanager_column__task_shm_hitalama_taskmanager_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager['task'] >
		,
		ReturnType< $shm_hitalama_taskmanager_column['task'] >
	>
	type $shm_hitalama_taskmanager_column__task_add_shm_hitalama_taskmanager_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager['task_add'] >
		,
		ReturnType< $shm_hitalama_taskmanager_column['task_add'] >
	>
	type $shm_hitalama_taskmanager_column__title_shm_hitalama_taskmanager_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_taskmanager_column['title'] >
	>
	type $shm_hitalama_taskmanager_column__status_shm_hitalama_taskmanager_7 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_taskmanager_column['status'] >
	>
	type $shm_hitalama_taskmanager_column__tasks_shm_hitalama_taskmanager_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager['tasks_by_status'] >
		,
		ReturnType< $shm_hitalama_taskmanager_column['tasks'] >
	>
	type $shm_hitalama_taskmanager_column__task_shm_hitalama_taskmanager_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager['task'] >
		,
		ReturnType< $shm_hitalama_taskmanager_column['task'] >
	>
	type $shm_hitalama_taskmanager_column__title_shm_hitalama_taskmanager_10 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_taskmanager_column['title'] >
	>
	type $shm_hitalama_taskmanager_column__status_shm_hitalama_taskmanager_11 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_taskmanager_column['status'] >
	>
	type $shm_hitalama_taskmanager_column__tasks_shm_hitalama_taskmanager_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager['tasks_by_status'] >
		,
		ReturnType< $shm_hitalama_taskmanager_column['tasks'] >
	>
	type $shm_hitalama_taskmanager_column__task_shm_hitalama_taskmanager_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager['task'] >
		,
		ReturnType< $shm_hitalama_taskmanager_column['task'] >
	>
	export class $shm_hitalama_taskmanager extends $mol_book2 {
		Theme( ): $mol_theme_auto
		tasks_by_status( id: any, next?: readonly(any)[] ): readonly(any)[]
		task( id: any, next?: any ): any
		task_add( next?: any ): any
		Todo( ): $shm_hitalama_taskmanager_column
		Progress( ): $shm_hitalama_taskmanager_column
		Done( ): $shm_hitalama_taskmanager_column
		plugins( ): readonly(any)[]
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=taskmanager.view.tree.d.ts.map